var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.124 5.777l-4.312.089-.071.006a.488.488 0 00-.213.87l3.435 2.59-1.248 4.103-.015.063a.488.488 0 00.759.48L8 11.527l3.541 2.451.055.033a.488.488 0 00.689-.575l-1.248-4.104 3.435-2.59.054-.046a.488.488 0 00-.338-.83l-4.312-.089-1.416-4.05a.487.487 0 00-.92 0l-1.416 4.05z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/star.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };